<template>
  <div
    v-if="store.latestVersion"
    class="py-2 px-4 text-base-content/50 overflow-auto"
  >
    <!-- 游戏名称 -->
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.updateLog.current") }}
        </h2>
      </div>
      <VanField
        v-model="store.latestVersion.version"
        class="bg-base-100 border rounded"
        disabled
        required
      />
    </div>

    <!-- 更新后版本号 -->
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.updateLog.later") }}
          <span class="text-[#E84B4B]">*</span>
        </h2>
      </div>
      <div class="flex items-center gap-2.5">
        <span>v</span>
        <input
          v-model="store.activeVersion.versionNumber[0]"
          class="w-10 text-center h-10 bg-transparent border border-my-dark"
          type="text"
        />
        <span>.</span>
        <input
          v-model="store.activeVersion.versionNumber[1]"
          class="w-10 text-center h-10 bg-transparent border border-my-dark"
          type="text"
        />
        <span>.</span>
        <input
          v-model="store.activeVersion.versionNumber[2]"
          class="w-10 text-center h-10 bg-transparent border border-my-dark"
          type="text"
        />
      </div>
    </div>
    <!-- 本次更新内容 -->
    <div>
      <div class="flex items-center justify-between mt-3 mb-2">
        <h2 class="text-base font-bold">
          {{ $t("game.updateLog.content") }}
        </h2>
      </div>
      <VanField
        v-model="store.activeVersion.description"
        :autosize="{ minHeight: 200 }"
        class="bg-base-100 border rounded"
        type="textarea"
      />
    </div>
    <div>
      <h2 class="text-base font-bold mt-3">
        {{ $t("game.updateLog.version") }}
      </h2>

      <ul>
        <li v-for="version in store.versionzz" :key="version.id">
          <h3 class="text-base font-bold my-2.5">v{{ version.version }}</h3>
          <p class="whitespace-pre-wrap">{{ version.description }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";

const store = useGalGameEditor();
</script>

<style scoped>
/* Your CSS code goes here */
</style>
